import { makeStyles } from 'makeStyles';
import { DISABLED_AND_BORDERS } from 'theme/colors';

export const useStyles = makeStyles()(() => ({
  dialogContent: {
    padding: 0,
    overflow: 'unset',
  },
  dialogFilter: {
    marginTop: 18,
  },
  teamText: {
    marginTop: 25,
    '& span': {
      fontWeight: 700,
    },
  },
  actionsContainer: {
    marginTop: 24,
    padding: '8px 0 8px 0',
  },
  teamDialogPaper: {
    padding: 40,
  },
  scrollingTableContainer: {
    overflow: 'auto',
    marginTop: '25px',
    maxHeight: '250px',
    border: `1px solid ${DISABLED_AND_BORDERS}`,
    borderRadius: 5,
    padding: 20,
  },
  playerFilterLabel: {
    '& .MuiFormControlLabel-label': {
      fontSize: '15px',
    },
  },
}));
